import request from '../../../config/Request'

const query = {
    queryStatisticsByCar:'/api/Statistics/queryStatisticsByCar',// 按车辆统计
    queryStatisticsByOrgan:'/api/Statistics/queryStatisticsByOrgan',// 按医疗机构统计
    queryEvent:'/api/Statistics/queryEvent',// 按事件查询
    queryStatisticsByGoodsType:'/api/Statistics/queryStatisticsByGoodsType',// 按医废种类查询
};
/**
 * 按车辆统计
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function queryStatisticsByCar(parameter) {
    return request({
        url: query.queryStatisticsByCar,
        data: parameter
    })
}
/**
 * 按医疗机构统计
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function queryStatisticsByOrgan(parameter) {
    return request({
        url: query.queryStatisticsByOrgan,
        data: parameter
    })
}
/**
 * 按医废种类查询
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function queryStatisticsByGoodsType(parameter) {
    return request({
        url: query.queryStatisticsByGoodsType,
        data: parameter
    })
}
/**
 * 按事件查询
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function queryEvent(parameter) {
    return request({
        url: query.queryEvent,
        data: parameter
    })
}
